// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__wJ5N_","alertIcon":"ConfirmModal_alertIcon__2nt34"};